// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import './styles/design-system.css';
import './styles/utility-classes.css';
import "./index.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import MainRouter from "./MainRouter";
import reportWebVitals from "./reportWebVitals";
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-big-calendar/lib/css/react-big-calendar.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
 // <React.StrictMode>
    <MainRouter />
 // </React.StrictMode>
);

reportWebVitals();